import { JSX } from "react";

import { Tab, Tabs, Theme, useTheme } from "@mui/material";
import useIntervalTabsStore from "src/store/intervalTabs.store";

import { IntervalTab, allIntervalTabs } from "./enum/IntervalTab";
import TabLabel from "./TabLabel";

interface IntervalTabsProps {
  selectedTab: IntervalTab;
  componentId: string;
}

const getStyles = (theme: Theme) => ({
  tabs: {
    height: 34,
    minHeight: 34,
  },
  tab: {
    height: 34,
    minHeight: 34,
    padding: 0,
    "&:hover": { backgroundColor: theme.palette.transparent.heavy },
    "&.Mui-selected": {
      backgroundColor: theme.palette.surface.subtle,
      borderBottomColor: theme.palette.brand.dark,
    },
    "&.Mui-selected p": { color: theme.palette.text.primary },
  },
});

function IntervalTabs({ selectedTab, componentId }: IntervalTabsProps): JSX.Element {
  const theme = useTheme();
  const { setSelectedTab } = useIntervalTabsStore();

  const handleTabClick = (_: unknown, newTab: IntervalTab): void => {
    setSelectedTab(newTab, componentId);
  };

  return (
    <Tabs value={selectedTab} variant='fullWidth' onChange={handleTabClick} sx={getStyles(theme).tabs}>
      {allIntervalTabs.map((intervalTab) => (
        <Tab key={intervalTab} sx={getStyles(theme).tab} value={intervalTab} label={<TabLabel intervalTab={intervalTab} />} />
      ))}
    </Tabs>
  );
}

export default IntervalTabs;
